import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { AuthService } from '../../../core/services/auth.service';
import { ModalRecoverComponent } from '../modal-recover/modal-recover.component';

@Component({
  selector: 'app-recover',
  templateUrl: './recover.component.html',
  styleUrls: ['./recover.component.scss']
})
export class RecoverComponent implements OnInit {

  public formRecovery: FormGroup;
  public loader = {
    recover: false
  };
  error;

  googleCaptchaSiteKey = environment.googleCaptchaSiteKey;
  googleCaptchaResponse: string;

  modalFinRef: MatDialogRef<ModalRecoverComponent>;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private _authService: AuthService,
    public dialog: MatDialog
  ) { 
    this.formRecovery = this.fb.group({
      rutEmpresa: [undefined, [Validators.required]],
      rutCliente: [undefined, [Validators.required]],
      email: [undefined, [Validators.required]],
      recaptchaReactive: ['', [Validators.required]]
    });

    this.error = {
      status: false,
      descripcion: ""
    };

  }

  ngOnInit(): void {
  }

  resolved(event) {
    this.googleCaptchaResponse = event;
    //console.log("RESPUESTA RECAPTCHA: ", event);
  }

  public get f() {
    return this.formRecovery.controls;
  }

  public async recover(): Promise<void> {
    if (this.formRecovery.valid) {
      try {
        this.loader.recover = true;
        const body = this.formRecovery.value;
        body.RecaptchaResponse = this.googleCaptchaResponse;
        const response = await this._authService.recuperarClave(body);
        if(response.error.codError === 0){
          //recupero ok 
          this.modalFinRef = this.dialog.open(ModalRecoverComponent, {
            height: "400px",
            width: "400px",
            data: {
              status: true,
              texto:
                "Recibirás un correo con tu nueva clave.",
            },
          });
          //this.router.navigate(['/auth']);
        }
        else{
          /*this.modalFinRef = this.dialog.open(ModalRecoverComponent, {
            height: "400px",
            width: "400px",
            data: {
              status: false,
              texto: "Revisa los datos he intenta de nuevo.",
            },
          });*/
          this.formRecovery.controls["recaptchaReactive"].setValue("");
          console.log("Error en recuperar contraseña: ", response.error.desError);
          this.error.status = true;
          this.error.descripcion = response.error.desError;
        }

        // const response = await this.authService.login(body);
        // if (response) {
        // } else {
        //   throw new Error("Error: Not data received.");
        // }
      } catch (error) {
        this.formRecovery.controls["recaptchaReactive"].setValue("");
        this.error.status = true;
        this.error.descripcion = error.error.error.desError;
      } finally {
        this.loader.recover = false;
      }
    }
  }

}


